import { render } from "./EditRegisterModal.vue?vue&type=template&id=f4c3e274&scoped=true"
import script from "./EditRegisterModal.vue?vue&type=script&lang=js"
export * from "./EditRegisterModal.vue?vue&type=script&lang=js"

import "./EditRegisterModal.vue?vue&type=style&index=0&id=f4c3e274&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4c3e274"]])

export default __exports__